export default __webpack_public_path__ + "static/media/AadhaarLogo.fd1ca104.svg";